import { lazy } from 'react'
import { defineFeature } from '@/app/features/types'
import { ROUTES } from '@/app/navigation'

const DashboardsRoutes = lazy(() =>
  import('./MetabaseRoutes').then((module) => ({ default: module.DashboardsRoutes })),
)
const IndicatorsRoutes = lazy(() =>
  import('./MetabaseRoutes').then((module) => ({ default: module.IndicatorsRoutes })),
)

export const feature = defineFeature({
  id: 'metabase',
  routes: [
    {
      path: `${ROUTES.metabaseDashboards}/*`,
      permission: 'metabase:read',
      Component: DashboardsRoutes,
    },
    {
      path: `${ROUTES.metabaseIndicators}/*`,
      permission: 'metabase:read',
      Component: IndicatorsRoutes,
    },
  ],
})
